<template>
  <div v-loading="loading">
    <div class="title">我的项目</div>
    <div class="search-box">
      <div>
        <div class="mb-12">
          <CascaderPosition
            size="medium"
            :job-id.sync="job_id"
          ></CascaderPosition>
          <el-select
            class="w-200 mr-12"
            size="medium"
            v-model="project_task_id"
            placeholder="项目需求说明"
          >
            <el-option
              v-for="item in projectTask"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
          <el-cascader
            v-model="common_industry_id"
            :options="industryList"
            :props="optionProps"
            placeholder="请选择行业分类"
            size="medium"
            class="w-200 mr-12"
            @change="search"
            clearable
          ></el-cascader>
        </div>
        <el-input
          class="mr-12 w-200"
          v-model="name"
          size="medium"
          placeholder="项目名称"
        />
        <el-select
          class="w-200 mr-12"
          size="medium"
          v-model="status"
          placeholder="状态"
        >
          <el-option :label="'提案中'" :value="1"></el-option>
          <el-option :label="'已提交'" :value="2"></el-option>
          <el-option :label="'生产中'" :value="3"></el-option>
          <el-option :label="'封测中'" :value="4"></el-option>
          <el-option :label="'已封测'" :value="5"></el-option>
          <el-option :label="'已拒绝'" :value="6"></el-option>
          <el-option :label="'已完成'" :value="7"></el-option>
        </el-select>
        <el-date-picker
          class="w-200 mr-12"
          v-model="end_date"
          type="date"
          size="medium"
          placeholder="截止时间"
        >
        </el-date-picker>

        <el-button type="primary" size="medium" plain @click="search"
          >查询</el-button
        >
        <el-button size="medium" @click="clearSearch">重置</el-button>
      </div>
    </div>
    <el-table :data="list" :stripe="true">
      <el-table-column width="50" label="编号" prop="id"></el-table-column>
      <el-table-column min-width="135" label="关联需求">
        <template slot-scope="scope">
          <div
            class="hidden-redundant"
            @click="
              openDialog(scope.row.task ? scope.row.task.description : '-')
            "
          >
            {{ scope.row.task ? scope.row.task.name : "-" }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="项目名称" prop="name"></el-table-column>
      <el-table-column width="100">
        <template slot="header">
          <div @click="toggleShowContent" class="toggle-show">
            <span>最终价格</span>
            <i class="el-icon-view toggle-show-icon"></i>
          </div>
        </template>
        <template slot-scope="scope">
          <show-hide-content
            :value="scope.row.teacher_production_price || '-'"
            :show.sync="isShow"
          ></show-hide-content>
        </template>
      </el-table-column>
      <el-table-column label="关联行业" width="120" show-overflow-tooltip>
        <template slot-scope="scope">
          {{
            (scope.row.common_industries || []).length
              ? String(
                  scope.row.common_industries.map(data => {
                    return data.name;
                  })
                )
              : "-"
          }}
        </template>
      </el-table-column>
      <el-table-column
        width="180"
        label="创建时间"
        prop="created_at"
      ></el-table-column>
      <el-table-column
        width="80"
        label="当前状态"
        prop="status_label"
      ></el-table-column>
      <el-table-column
        v-if="authPermissions.includes('project.api.fuwu_admin.projects.show')"
        width="80"
        label="操作"
      >
        <template slot-scope="scope">
          <el-link
            type="primary"
            :underline="false"
            @click="goProjectDetail(scope.row.id)"
            >详情</el-link
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      layout="total, prev, pager, next, jumper"
      @current-change="goPage"
      :current-page.sync="pagination.currentPage"
      :page-size="pagination.pageSize"
      :total="pagination.total"
      :hide-on-single-page="true"
    >
    </el-pagination>

    <el-dialog
      class="skill-task-dialog"
      :visible.sync="dialogVisible"
      width="1000px"
      :show-close="false"
      center
    >
      <markdown-it :md="dialogDescription"></markdown-it>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import projectService from "@/global/service/project";
import kcellService from "@/global/service/kcell";
import MarkdownIt from "@jiker/markdown-it/MarkdownIt.vue";
import CascaderPosition from "./widgets/CascaderPosition.vue";
import ShowHideContent from "@/components/ShowHideContent";

export default {
  components: {
    MarkdownIt,
    CascaderPosition,
    ShowHideContent
  },
  data() {
    return {
      loading: true,
      isShow: false,
      selectLoading: false,
      projectTask: [],
      list: [],
      job_id: null,
      name: "",
      status: "",
      end_date: null,
      project_task_id: null,
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      dialogVisible: false,
      dialogDescription: "",
      common_industry_id: null,
      industryList: [],
      optionProps: {
        value: "id",
        label: "name",
        children: "children",
        emitPath: false
      }
    };
  },
  computed: {
    ...mapState(["authPermissions"])
  },
  created() {
    this.getData();
    this.getProjectTask();
    this.getConst();
  },
  watch: {
    $route() {
      this.getData();
    }
  },
  methods: {
    getData() {
      const page = Number(this.$route.query.page) || 1;
      const params = {
        page,
        page_size: this.pagination.pageSize,
        job_id: this.job_id,
        name: this.name,
        status: this.status,
        end_date: this.end_date,
        project_task_id: this.project_task_id,
        common_industry_id: this.common_industry_id
      };
      this.loading = true;
      projectService
        .list(params)
        .then(res => {
          this.list = res.list;
          this.pagination.currentPage = Number(res.pagination.current_page);
          this.pagination.total = Number(res.pagination.total);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getProjectTask() {
      projectService
        .task({
          page: 1,
          page_size: 100
        })
        .then(res => {
          this.projectTask = res.list;
        });
    },
    getConst() {
      kcellService.kcellIndustry().then(res => {
        this.industryList = res;
      });
    },
    openWay() {
      window.open("https://jiker.feishu.cn/docs/doccnRmZ65RsEEMaCoitBqPGXab");
    },
    goProjectDetail(id) {
      this.$router.push({
        name: "ProjectMyDetail",
        params: { id }
      });
    },
    openDialog(description) {
      this.dialogVisible = true;
      this.dialogDescription = description;
    },
    toggleShowContent() {
      this.isShow = !this.isShow;
    },
    goPage(val) {
      this.$router.push({
        name: "ProjectMySelf",
        query: { page: val }
      });
    },
    search() {
      this.getData();
    },
    clearSearch() {
      this.job_ids = [];
      this.name = null;
      this.status = null;
      this.end_date = null;
      this.project_task_id = null;
      this.common_industry_id = null;
      this.getData();
    }
  }
};
</script>

<style lang="less">
.skill-task-dialog {
  .el-dialog__header,
  .el-dialog__body {
    padding: 0;
  }
}
</style>
<style lang="less" scoped>
.search-box {
  display: flex;
  justify-content: space-between;
  margin-bottom: 12px;
}
.hidden-redundant {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
  &:hover {
    color: #409eff;
  }
}
</style>
